<!--多功能Image控件-->
<template>
  <div
    class="imgCon"
    :style="{width: width + 'px', height: height + 'px'}"
    v-loading="loading"
  >
    <img :src="originalSrc" :key="index" class="imgStyle">
    <p class="imgTip" @click="openBig">点击查看大图</p>
    <a
      v-if="delBtn"
      class="closeBtn"
      @click="deleteBtn"
    ></a>
  </div>
</template>

<script>
  export default {
    name: 'MultiImage'
    , data () {
      return {
        // picDialogShow: false
        // , loading: false
      }
    }
    , props: {
      width: {
        type: Number
        , default: 105
      }
      , height: {
        type: Number
        , default: 142
      }
      , src: {
        type: String
        , default: require('@/assets/logo.png')
      }
      , originalSrc: {
        type: String
        , default: require('@/assets/logo.png')
      }
      , index: {
        type: Number
      }
      , adapter: {
        type: Array
      }
      , loading: {
        type: Boolean
        , default: true
      }
      , delBtn: {
        type: Boolean
        , default: true
      }
    }
    , methods: {
      // 点击查看大图
      openBig () {
        console.log(this.$el)
        const viewer = this.$el.parentNode.$viewer
        if (viewer){
          viewer.index = this.index
          viewer.show()
        }
      }
      // 删除按钮
      , deleteBtn () {
        var that = this
        this.$confirm('确认删除该附件吗?', '提示', {
          confirmButtonText: '确定'
          , cancelButtonText: '取消'
          , type: 'warning'
        }).then(() => {
          this.$emit('eventCallback', {
            type: 'del'
            , index: this.index
            , adapter: that.adapter
          })

        }).catch(() => {
          this.$message({
            type: 'info'
            , message: '已取消删除'
          })
        })
      }
    }
    , created () {

    }
    , watch: {
      loading (val) {
        console.log(val)
      }
    }
  }
</script>

<style scoped>
  .imgCon {
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    border: 1px solid #BABABA;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    transition: all 150ms linear;
    margin: 5px;
  }

  p, div, input {
    overflow: hidden;
    transition: all .3s;
    margin: 0;
    padding: 0;
  }

  p, a {
    transition: all 150ms linear;
  }

  .imgCon:hover {
    border: 2px solid #3492FF;
  }

  .imgCon:hover .imgTip {
    bottom: 0;
    opacity: 1;
  }

  .imgCon:hover .closeBtn {
    top: 3px;
    opacity: 1;
  }

  .imgTip {
    position: absolute;
    background: #3492FF;
    height: 24px;
    width: 100%;
    line-height: 24px;
    font-size: 12px;
    color: #FFFFFF;
    text-align: center;
    bottom: -24px;
    left: 0;
    opacity: 0;
    cursor: pointer;
  }

  .imgTip:hover {
    text-decoration: underline;
  }

  .closeBtn {
    position: absolute;
    width: 16px;
    height: 16px;
    background: url("../assets/del-btn.png");
    right: 4px;
    top: -16px;
    opacity: 0;
  }

  .imgStyle {
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/MultiImage.vue